<template>
    <modalConfirmation ref="modal">
      <div id="sub-sub-wrapper">
        <div>{{ $t('pages.studio.live.confirmation.start.title') }}</div>
        <div>
          <div v-for="distributor in distributors" :key="distributor.kind">
            <img :src='imgSrc(distributor.kind)'/>
          </div>
        </div>
        <div v-html="$t('pages.studio.live.confirmation.start.text')"></div>
      </div>
    </modalConfirmation>
</template>

<script>
import distributor from '@/services/distributor'

export default {
  props: {
    distributors: Array
  },
  methods: {
    show () {
      return this.$refs.modal.show('', this.$i18n.t('pages.studio.live.confirmation.start.yes'), this.$i18n.t('pages.studio.live.confirmation.start.no'))
    },
    hide () {
      this.$refs.modal.hide()
    },
    imgSrc (kind) {
      return distributor.imgSrc(kind)
    }
  }
}
</script>

<style scoped>

#sub-sub-wrapper > div:nth-child(1) {
  font-size: 1.5em;
  margin-bottom: 1em;
}

#sub-sub-wrapper > div:nth-child(2) {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 1.5em;
}

#sub-sub-wrapper > div:nth-child(2) > div {
  background-color: #7c7c7c;
  border-radius: 0.3em;
  margin-right: 0.5em;
  padding: 0.5em 1em;
}

#sub-sub-wrapper > div:nth-child(2) > div:last-child {
  margin-right: 0;
}

#sub-sub-wrapper > div:nth-child(2) > div > img {
  display: block;
  width: 2em;
}

</style>
